/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_Tlm_1Inputs */

const en_svc_mvp_sprint_tlm_1 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`demos`)
};

const ar_svc_mvp_sprint_tlm_1 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العروض`)
};

const bn_svc_mvp_sprint_tlm_1 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডেমো`)
};

const de_svc_mvp_sprint_tlm_1 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demos`)
};

const es_svc_mvp_sprint_tlm_1 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demos`)
};

const fr_svc_mvp_sprint_tlm_1 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démos`)
};

const pt_svc_mvp_sprint_tlm_1 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demos`)
};

const zh_svc_mvp_sprint_tlm_1 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`演示`)
};

const tr_svc_mvp_sprint_tlm_1 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demolar`)
};

const ru_svc_mvp_sprint_tlm_1 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Демо`)
};

const pl_svc_mvp_sprint_tlm_1 = /** @type {(inputs: Svc_Mvp_Sprint_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dema`)
};

/**
* | output |
* | --- |
* | "demos" |
*
* @param {Svc_Mvp_Sprint_Tlm_1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_tlm_1 = /** @type {((inputs?: Svc_Mvp_Sprint_Tlm_1Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_Tlm_1Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_tlm_1(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_tlm_1(inputs)
	if (locale === "de") return de_svc_mvp_sprint_tlm_1(inputs)
	if (locale === "es") return es_svc_mvp_sprint_tlm_1(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_tlm_1(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_tlm_1(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_tlm_1(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_tlm_1(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_tlm_1(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_tlm_1(inputs)
	return en_svc_mvp_sprint_tlm_1(inputs)
});
export { svc_mvp_sprint_tlm_1 as "svc_mvp-sprint_tlm_1" }